<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import displayItem from '@/components/display-item'
import userAccountEditForm from '@/components/user-account-edit'
import userAddressEditForm from '@/components/user-address-edit'

export default {
  name: 'user-details',
  components: {
    'display-item': displayItem,
    'user-account-edit-form': userAccountEditForm,
    'user-address-edit-form': userAddressEditForm
  },
  computed: {
    ...mapGetters([ 'getCartId' ]),
    ...mapState([ 'account', 'addresses' ]),
    fullName () {
      return `${this.account.firstName} ${this.account.lastName}`
    }
  },
  created () {
    this.aFetchAccount()
    this.aFetchAddresses()
  },
  data () {
    return {
      accountEditDialogVisible: false,
      addressEditDialogVisible: false,
      address: {}
    }
  },
  methods: {
    ...mapActions([
      'aFetchAccount',
      'aFetchAddresses'
    ]),
    addressItemsToDisplay (addr) {
      let lines = []

      if (addr.name) {
        lines.push(addr.name)
      }
      lines.push(`${addr.street}${addr.number ? ` ${addr.number}${addr.apartment ? `/${addr.apartment}` : ''}` : ''}`)
      lines.push(`${addr.zip}, ${addr.place}`)
      lines.push(`${addr.country}`)
      if (addr.phone) {
        lines.push(`${addr.phone}`)
      }
      if (addr.taxNumber) {
        lines.push(`NIP ${addr.taxNumber}`)
      }
      return lines
    },
    changeAddress (address) {
      this.address = address || {}
      this.addressEditDialogVisible = true
      this.addressEditForm = true
    },
    getAddressLabel (address) {
      let label = []
      if (address.defaultShipment) {
        label.push('wysyłka')
      }
      if (address.invoiceBuyer) {
        label.push('FV/nabywca')
      }
      if (address.invoiceRecipient) {
        label.push('FV/odbiorca')
      }
      return `${label.length ? label.join(', ') : '___'}`
    },
    updateAccountEditDialog (isVisible) {
      this.aFetchAccount()
      this.accountEditDialogVisible = isVisible
    },
    updateAddressEditDialog (isVisible) {
      this.address = {}
      this.aFetchAddresses()
      this.addressEditDialogVisible = isVisible
    }
  }
}
</script>

<template>
  <el-main class="user-details">
    <h1>Twój profil</h1>
    <h2>
      Konto
      <el-tooltip content="Zmień podstawowe dane w koncie.">
        <el-button
          @click="accountEditDialogVisible = true"
          type="primary"
          icon="el-icon-edit"
          size="mini"
          plain
          circle
        ></el-button>
      </el-tooltip>
    </h2>
    <el-row
      type="flex"
      class="tiles"
    >
      <display-item label="imię i nazwisko">{{ fullName }}</display-item>
      <display-item label="email">{{ account.email }}</display-item>
      <display-item label="telefon">{{ account.phone }}</display-item>
    </el-row>
    <el-dialog
      title="Zmiana danych konta"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :show-close="false"
      :visible="accountEditDialogVisible"
    >
      <user-account-edit-form @update:visible="updateAccountEditDialog"></user-account-edit-form>
    </el-dialog>
    <el-dialog
      :title="address.addressId ? 'Zmiana adresu' : 'Nowy adres'"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :show-close="false"
      :visible="addressEditDialogVisible"
    >
      <user-address-edit-form
        v-if="addressEditDialogVisible"
        :initialAddress="address"
        @update:visible="updateAddressEditDialog"
      ></user-address-edit-form>
    </el-dialog>
    <h2>Adresy <el-button
        type="primary"
        icon="el-icon-plus"
        size="mini"
        plain
        circle
        @click="changeAddress()"
      ></el-button>
    </h2>
    <el-row
      type="flex"
      class="tiles"
    >
      <display-item
        v-for="address in addresses"
        :key="address.address_id"
        :label="getAddressLabel(address)"
      >
        <ul class="flat">
          <li
            v-for="(item,index) in addressItemsToDisplay(address)"
            :key="index"
          >{{ item }}</li>
          <li class="buttons">
            <el-button
              @click="changeAddress(address)"
              icon="el-icon-edit"
              size="mini"
              circle
              plain
            ></el-button>
          </li>
        </ul>
      </display-item>
    </el-row>
  </el-main>
</template>



// WEBPACK FOOTER //
// src/components/user-details.vue